import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { useMerchant } from '../context/MerchantContext';

const Bar = styled.nav`
  display: none;

  @media (max-width: 992px) {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1030;
    background-color: #ffffff;
    border-top: 1px solid #e2e8f0;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
    padding-bottom: env(safe-area-inset-bottom, 0);
  }
`;

const NavItem = styled.button<{ active?: boolean; themeColor?: string }>`
  flex: 1;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  padding: 0.5rem 0 0.55rem;
  color: ${props => (props.active ? (props.themeColor || '#e74c3c') : '#718096')};
  transition: color 0.2s;

  i {
    font-size: 1.25rem;
  }

  span {
    font-size: 0.7rem;
    font-weight: 600;
  }
`;

const IconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Badge = styled.span<{ themeColor?: string }>`
  position: absolute;
  top: -6px;
  right: -10px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background-color: ${props => props.themeColor || '#e74c3c'};
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useCart();
  const { isAuthenticated, setShowLoginModal } = useAuth();
  const { restaurant, isCartOpen, setIsCartOpen } = useMerchant();

  const themeColor = restaurant?.theme?.primary || '#e74c3c';
  const cartItemCount = state.items.reduce((count, item) => count + item.quantity, 0);
  const path = location.pathname;

  const isHomeActive = path === '/' || path === '/home' || path.startsWith('/menu');
  const isOrdersActive = path.startsWith('/pedidos');
  const isAccountActive = path.startsWith('/perfil');

  const handleAccount = () => {
    if (isAuthenticated) {
      navigate('/perfil');
    } else {
      setShowLoginModal(true);
    }
  };

  return (
    <Bar>
      <NavItem
        type="button"
        themeColor={themeColor}
        active={isHomeActive && !isCartOpen}
        onClick={() => navigate('/')}
      >
        <IconWrapper>
          <i className="fas fa-home" />
        </IconWrapper>
        <span>Início</span>
      </NavItem>

      <NavItem
        type="button"
        themeColor={themeColor}
        active={isOrdersActive && !isCartOpen}
        onClick={() => navigate('/pedidos')}
      >
        <IconWrapper>
          <i className="fas fa-receipt" />
        </IconWrapper>
        <span>Pedidos</span>
      </NavItem>

      <NavItem
        type="button"
        themeColor={themeColor}
        active={isCartOpen}
        onClick={() => setIsCartOpen(true)}
      >
        <IconWrapper>
          <i className="fas fa-shopping-basket" />
          {cartItemCount > 0 && <Badge themeColor={themeColor}>{cartItemCount}</Badge>}
        </IconWrapper>
        <span>Sacola</span>
      </NavItem>

      <NavItem
        type="button"
        themeColor={themeColor}
        active={isAccountActive && !isCartOpen}
        onClick={handleAccount}
      >
        <IconWrapper>
          <i className="fas fa-user" />
        </IconWrapper>
        <span>Conta</span>
      </NavItem>
    </Bar>
  );
};

export default BottomNav;
